import React from 'react';
import './LeftSideBar.css';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { userDetail } from '../../../Redux/userSlice';
import { useSportsExchange } from '../../../hooks/useSportsExchange';
import { useThemeColor } from '../../../hooks/useThemeColor';
import ThemeChanger from '../ThemeChanger/ThemeChanger';

const LeftSideBar = ({ selectedLeftBarData, setSelectedLeftBarData, leftSideBarData, }) => {

    const { colorMode } = useThemeColor();

    const navigate = useNavigate();
    // const dispatch = useDispatch();
    const user = useSelector(userDetail);
    const { exchangeLaunchFunction } = useSportsExchange();

    const changeStateFunc = (item) => {
        // console.log(user?.is_login, item.name);
        if (item.name === "In-Play") {
            if (!user?.is_login) {
                console.log(item.name);
                navigate("/login");
            } else {
                exchangeLaunchFunction(1);
            }
        } else if (item.name === "Today") {
            if (!user?.is_login) {
                navigate("/login");
            } else {
                exchangeLaunchFunction(2);
            }
        } else if (item.name === "Tomorrow") {
            if (!user?.is_login) {
                navigate("/login");
            } else {
                exchangeLaunchFunction(3);
            }
        } else if (item?.to === "mood") {

        } else {
            setSelectedLeftBarData(item);
        }
    }
    return (
        <div className="left-bar rounded pb-1">
            {
                leftSideBarData?.map(item =>
                    <Link
                        key={item?.id}
                        to={
                            (item?.to) !== "mood"
                            &&
                            item?.to
                        }
                        className={(selectedLeftBarData?.name === item?.name) ? 'active rounded custom-shadow mb-2' : 'sqrBtn rounded custom-shadow mb-2'}
                        onClick={() => changeStateFunc(item)}
                        style={{ textDecoration: "none" }}
                    >
                        <div className='d-flex flex-column justify-content-center align-items-center m-0 p-0 text-center'>
                            {
                                item?.to === "mood" ?
                                    <ThemeChanger />
                                    :
                                    <>
                                        {/* <img src={(selectedLeftBarData?.name === item?.name) ? item?.icon1 : item?.icon2} alt={item?.name} /> */}
                                        <img src={(colorMode === "dark") ? item?.icon1 : item?.icon2} alt={item?.name} />
                                    </>
                            }
                            <p>{(item?.to !== "mood") ? item?.name : ((colorMode === "dark") ? "Light" : (colorMode === "light") ? "Dark" : item?.name)}</p>
                        </div>
                    </Link>
                )
            }
        </div>
    );
};

export default LeftSideBar;